import React, { useState, useEffect } from 'react';
import {Skeleton, Alert, Form, Input, Button, message} from "antd";
import {useParams} from "react-router-dom";
import {useMutation, useQuery} from "react-query";
import {GetDeveloper, UpdateDeveloperPage} from "../../../../../api/console";
import {MediaUpload} from "./Store.controller";

export const EditPageController = () => {
    const params = useParams();
    const { developer_id } = params;
    const [appMedia, setAppMedia] = useState([]);

    const DeveloperResponse = useQuery(
        ['developer', developer_id],
        () => GetDeveloper(developer_id)
    );

    const UpdateDeveloperMutation = useMutation(
        (data) => UpdateDeveloperPage(developer_id, data),
        {
            onSuccess: (data, vars) => {
                message.success(`Страница успешно обновлена`);
            },
            onError: (e) => {
                console.error(`[UpdateDeveloperMutation] `, e.response);
                message.error(e?.response?.data?.message || "Во время запроса произошла ошибка");
            }
        }
    )

    useEffect(() => {
        if (DeveloperResponse?.data?.developer && DeveloperResponse?.data?.developer?.media) {
            setAppMedia(DeveloperResponse?.data?.developer?.media || [])
        }
    }, [DeveloperResponse?.data?.developer])

    if (DeveloperResponse.isLoading) {
        return (
            <div className={`dev__layout account`}><Skeleton /></div>
        )
    }

    const profile = DeveloperResponse?.data?.developer || {};



    return (
        <div className={`dev__layout account`}>
            <h1>Настройка страницы разработчика</h1>
            <Alert
                type={`info`}
                message={`Эти данные увидит пользователь, переходя на страницу вашего аккаунта`}
            />
            <div className="account__form form__bg">
                <Form
                    layout={`vertical`}
                    onFinish={(values) => {
                        UpdateDeveloperMutation.mutate({...values, ...{media: appMedia.map(i => i.hash)}})
                    }}
                    initialValues={{
                        title: profile?.title || "",
                        description: profile?.description || "",
                    }}
                >
                    <Form.Item name={`title`} label={`Заголовок`} rules={[{required: true, message: `Заполните заголовок`}]}>
                        <Input maxLength={80} placeholder={`Введите название разработчика, которое увидят пользователи`} showCount={true}/>
                    </Form.Item>
                    <Form.Item name={`description`} label={`Описание`}>
                        <Input.TextArea maxLength={400} placeholder={`Введите описание разработчика, , которое увидят пользователи`} showCount={true}/>
                    </Form.Item>
                    <MediaUpload
                        title={`Логотип разработчика`}
                        extra={`Поддерживаются JPG/PNG, максимальный размер 1МБ, размер изображения должен быть 512x512`}
                        accept={'.jpg,.jpeg,.png'}
                        acceptTypes={['image/jpg', 'image/jpeg', 'image/png']}
                        maxSize={1048576}
                        mediaCount={1}
                        mediaType={'developer_logo'}
                        app_id={developer_id}
                        developer_id={developer_id}
                        appMedia={appMedia}
                        setAppMedia={setAppMedia}
                    />
                    <MediaUpload
                        title={`Обложка`}
                        extra={`Загрузите от 2 до 8 скриншотов. Скриншоты должны быть в формате PNG/JPEG. Соотношение сторон 16:9 или 9:16, максимальный размер одного файла 5МБ.`}
                        accept={'.jpg,.jpeg,.png'}
                        acceptTypes={['image/jpg', 'image/jpeg', 'image/png']}
                        maxSize={5242880}
                        mediaCount={1}
                        mediaType={'developer_cover'}
                        sort={true}
                        app_id={developer_id}
                        developer_id={developer_id}
                        appMedia={appMedia}
                        setAppMedia={setAppMedia}
                    />
                    <div className={`store--button__full`}>
                        <Button type={`primary`} htmlType={`submit`} loading={UpdateDeveloperMutation.isLoading}>Сохранить</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default EditPageController;